import * as yup from 'yup';
import { requiredImageFromCMSSchema } from '../../cms/schemas';

const tipCardSchema = yup
  .object({
    content: yup.string(),
    icon: requiredImageFromCMSSchema,
  })
  .transform(value =>
    value
      ? {
          content: value.content,
          icon: value.icon,
        }
      : {},
  );

export const schema = yup
  .object({ cards: yup.array(tipCardSchema), title: yup.string() })
  .transform(value =>
    value ? { cards: value.cards, title: value.title } : undefined,
  );
